import { createFileRoute } from "@tanstack/react-router";
import { EntityAdmin } from "@/components/Entities/Admin";
import { useParams } from "@/lib/navigation";

function RouteComponent() {
  const params = useParams();
  const entityId = params?.id as string;

  return <EntityAdmin entityId={entityId} />;
}

export const Route = createFileRoute("/_authenticated/entities/$id/")({
  component: RouteComponent,
  staticData: { page: "entities" },
});
